import script from "./ConfirmDialogue.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=22166618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22166618"]])

export default __exports__